// extracted by mini-css-extract-plugin
module.exports = {"transfersNotification":"IncomeTransfers_transfersNotification__12jSx","transferWrapper":"IncomeTransfers_transferWrapper__3-c3W","transferId":"IncomeTransfers_transferId__A2Rio"};